import { httpPost } from "utils/httpRequest"

const upsertPractitioner = async ({
  memberId,
  practitionerType,
  title,
  organization,
  licenseNumber,
}) => {
  const resp = await httpPost("admin/practitioner/upsert", {
    memberId,
    practitionerType,
    title,
    organization,
    licenseNumber,
  })
  return resp.data
}

const disablePractitioner = async ({ memberId }) => {
  const resp = await httpPost("admin/practitioner/disable", { memberId })
  return resp.data
}

const getPractitionerStatus = async ({ memberId }) => {
  const resp = await httpPost("admin/practitioner/status", { memberId })
  return resp.data
}

const enableSuperAdmin = async ({ memberId }) => {
  const resp = await httpPost("admin/practitioner/enableSuperAdmin", { memberId })
  return resp.data
}

const disableSuperAdmin = async ({ memberId }) => {
  const resp = await httpPost("admin/practitioner/disableSuperAdmin", { memberId })
  return resp.data
}

const assignClient = async ({ practitionerMemberId, clientMemberId }) => {
  const resp = await httpPost("admin/practitioner/assignClient", {
    practitionerMemberId,
    clientMemberId,
  })
  return resp.data
}

const unassignClient = async ({ practitionerMemberId, clientMemberId }) => {
  const resp = await httpPost("admin/practitioner/unassignClient", {
    practitionerMemberId,
    clientMemberId,
  })
  return resp.data
}

const listClients = async ({ practitionerMemberId, pageNo = 1, pageSize = 50 }) => {
  const resp = await httpPost("admin/practitioner/listClients", {
    practitionerMemberId,
    pageNo,
    pageSize,
  })
  return resp.data
}

export {
  upsertPractitioner,
  disablePractitioner,
  getPractitionerStatus,
  enableSuperAdmin,
  disableSuperAdmin,
  assignClient,
  unassignClient,
  listClients,
}
